import { useEffect } from "react";
import { useSelector } from "react-redux";

import {
  logUserAssignedToVariant,
  useFeatureFlag
} from "features/feature-flags";
import { isUserRecoveryEmailAdTarget } from "features/user/selectors";

import { RECOVERY_EMAIL_AD_TEST_ID, RECOVERY_EMAIL_AD_VARIANT } from "./consts";

export function useLogUserAssignedToRecoveryEmailABTest() {
  const variant = useFeatureFlag(RECOVERY_EMAIL_AD_TEST_ID);
  const isAdTarget = useSelector(isUserRecoveryEmailAdTarget);
  useEffect(() => {
    if (variant && isAdTarget) {
      logUserAssignedToVariant({ variant, testId: RECOVERY_EMAIL_AD_TEST_ID });
    }
  }, [variant, isAdTarget]);
}

export function useShowRecoveryEmailGating() {
  const variant = useFeatureFlag(RECOVERY_EMAIL_AD_TEST_ID);
  const isAdTarget = useSelector(isUserRecoveryEmailAdTarget);
  return (
    isAdTarget && variant === RECOVERY_EMAIL_AD_VARIANT.TRIGGER_WITH_GATING
  );
}

export function useShowRecoveryEmailMandatory() {
  const variant = useFeatureFlag(RECOVERY_EMAIL_AD_TEST_ID);
  const isAdTarget = useSelector(isUserRecoveryEmailAdTarget);
  return isAdTarget && variant === RECOVERY_EMAIL_AD_VARIANT.MANDATORY;
}
